export const defaultTopics: string[] = [
  'Background experience',
  'Professional experience',
  'Motivation',
];
